<template>
  <div>
    <div class="tab-content-inner">
      
        <div class="action-buttons d-flex w-100 justify-content-end  p-2">
          <button
            class="reload-btn"
            @click="reload"
            :disabled="loading"
            v-b-tooltip.hover
            :title="$t('globals.reload')"
          >
            <icon name="sync-alt" :spin="loading"></icon>
          </button>
          <b-button variant="success" @click="openNewTaskModal = true" :disabled="loading">
            {{ $t("globals.new") }} {{ $t("globals.fieldtracker_task_name") }}
          </b-button>
        </div>
      
    </div>
    <div class="table-wrapper">
        <table class="modern-table">
          <thead>
            <tr>
              <th v-for="field in fields" :key="field.key"  @click="field.sortable && handleSort(field.key)" :style="{ cursor: field.sortable ? 'pointer' : 'default' }">
                {{ field.label }}
                <span v-if="sortBy === field.key" class="sort-icon">
                  {{ sortDesc ? '▼' : '▲' }}
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in task"
              :key="item.id"
              class="table-row"
            >
              <td>{{ item.id }}</td>
              <td>{{ item.device_type }}</td>
              <td>{{ item.task }}</td>
              <td>{{ item.api_identifier }}</td>
              <td>{{ item.imei }}</td>
              <td>{{ item.license_plate }}</td>
              <td>{{ item.billing_item ? item.billing_item.item_name : '' }}</td>
              <td>  
                <button @click="deleteTask(item.id)" :disabled="loading" variant="danger" class="btn btn-danger btn-sm">
                  {{ $t("globals.delete") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
    </div>
    <ulu-ft-new-task-modal :device_types="device_types" :tasks="device_tasks" :visible="openNewTaskModal" :ft_task="getAllTaskTypes" @close="closeNewTaskModal"/>
  </div>
  
  
</template>

<script>
  import { mapGetters, mapActions, mapMutations } from "vuex";
  import "vue-awesome/icons/sync-alt";
  export default {
    name: "AllTasks",
    components: {
      'ulu-ft-new-task-modal': () => import('@/components/admin/fieldtracker/NewTaskModal.vue'),
      Icon: () => import("vue-awesome/components/Icon.vue"),
    },
    data() {
      return {
        task:[],
        device_types:{},
        device_tasks:{},
        loading: false,
        openNewTaskModal: false,
        fields: [
          { key: "id", label: this.$t("globals.id"), sortable: true },
          { key: "device_type", label: this.$t("fieldtracker.device_type"), sortable: true },
          { key: "task", label: this.$t("fieldtracker.task"), sortable: true },
          { key: "api_identifier", label: this.$t("fieldtracker.api_identifier"), sortable: false },
          { key: "imei", label: this.$t("fieldtracker.imei_identifier"), sortable: false },
          { key: "license_plate", label: this.$t("fieldtracker.license_plate_identifier"), sortable: false },
          { key: "billing_item", label: this.$t("globals.order_include_item"), sortable: false },
          { key: "actions", label: this.$t("globals.actions"), sortable: false },
          
        ],
        sortBy: "id",
        sortDesc: false,
      };
    },
    methods: {
      ...mapActions("axios_mod", ["simpleFetch", "simpleMutation"]),
      ...mapMutations("loading", ["setLoading"]),
      getData(){
        
        const data = {
          query: `
            query {
              device_types
              device_tasks
              fieldtrackerTasks {
                id
                device_type
                task
                api_identifier
                license_plate
                imei
                billing_item{
                  id
                  item_name
                }
              }
            }
          `
        };
        
        this.loading = true;
        this.simpleFetch({ data, this_ref: this })
          .then(res => {
            
            if (res) {
             
              this.device_types = typeof res.device_types === "string" ? JSON.parse(res.device_types) : res.device_types
              this.device_tasks = typeof res.device_tasks === "string" ? JSON.parse(res.device_tasks) : res.device_tasks
              this.task = typeof res.fieldtrackerTasks === "string" ? JSON.parse(res.fieldtrackerTasks) : res.fieldtrackerTasks
            }
          })
          .finally(() => {
            this.loading = false;
          });
          
      },
      deleteTask(id){
        const data = {
          query: `
            mutation {
              res: FieldtrackerTaskDelete(id: ${id})
            }
          `,
          
        };
        this.simpleMutation({ data, this_ref: this }).then(() => {
          this.getData();
        });
      },
      closeNewTaskModal(){
        this.openNewTaskModal = false;
        this.getData();
      },
      handleSort(fieldKey) {
        if (this.sortBy === fieldKey) {
          this.sortDesc = !this.sortDesc;
        } else {
          this.sortBy = fieldKey;
          this.sortDesc = false;
        }
        this.task.sort((a, b) => {
          let result = 0;
          if (a[fieldKey] < b[fieldKey]) result = -1;
          if (a[fieldKey] > b[fieldKey]) result = 1;
          return this.sortDesc ? -result : result;
        });
      },
      reload(){
        this.getData();
      }
    },
    computed: {
      ...mapGetters("loading", ["isLoading"]),
      ...mapGetters("fieldtracker", ["getAllTaskTypes"]),
    },
    mounted(){
      this.getData();
    },
  };
  
</script>